import { Reveal, Eyebrow } from "./Reveal";
import { BEATS, THEMES } from "../data/content";

export const Story = () => (
    <section id="story" data-testid="story-section" className="relative mx-auto max-w-[1500px] px-5 sm:px-8 py-24 sm:py-36">
        <Reveal>
            <Eyebrow>The Series</Eyebrow>
            <h2
                data-testid="story-logline"
                className="max-w-5xl font-serif text-2xl sm:text-3xl lg:text-[2.7rem] leading-[1.55] text-zinc-100"
            >
                A college journalist investigates her best friend's murder — while falling for the{" "}
                <span className="italic text-[#d6c68e]">charismatic prime suspect</span> whose case puts
                their small town under a relentless media spotlight.
            </h2>
        </Reveal>

        <div className="mt-16 sm:mt-24 grid gap-px bg-white/10 md:grid-cols-3">
            {BEATS.map((b, i) => (
                <Reveal key={b.num} delay={i * 0.12} className="bg-[#0b1220]">
                    <div data-testid={`story-beat-${b.num}`} className="group h-full p-8 sm:p-10 transition-colors duration-500 hover:bg-[#0d1a2c]">
                        <span className="font-display text-5xl text-stroke-red transition-colors duration-500 group-hover:text-[#d6c68e] group-hover:[-webkit-text-stroke:0]">
                            {b.num}
                        </span>
                        <h3 className="mt-6 font-display text-2xl tracking-[0.06em] text-white">{b.title.toUpperCase()}</h3>
                        <p className="mt-4 text-sm sm:text-base leading-relaxed text-zinc-400">{b.text}</p>
                    </div>
                </Reveal>
            ))}
        </div>

        <Reveal delay={0.15} className="mt-14">
            <div data-testid="story-themes" className="flex flex-wrap items-center gap-3">
                <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 mr-2">THEMES /</span>
                {THEMES.map((t) => (
                    <span
                        key={t}
                        className="border border-white/15 px-4 py-1.5 font-mono text-[11px] tracking-[0.15em] text-zinc-300 transition-colors duration-300 hover:border-[#d6c68e] hover:text-[#d6c68e] cursor-default"
                    >
                        {t}
                    </span>
                ))}
            </div>
        </Reveal>
    </section>
);
